var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Pie Chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64676 6.90734H14.0934C14.2402 6.90734 14.3809 6.84904 14.4847 6.74527C14.5885 6.6415 14.6468 6.50076 14.6468 6.354C14.6468 5.02792 14.12 3.75615 13.1823 2.81847C12.2446 1.88079 10.9728 1.354 9.64676 1.354C9.5 1.354 9.35926 1.4123 9.25549 1.51607C9.15172 1.61984 9.09342 1.76058 9.09342 1.90734V6.354C9.09342 6.50076 9.15172 6.6415 9.25549 6.74527C9.35926 6.84904 9.5 6.90734 9.64676 6.90734Z",
    fill: "#1271A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0333 8.0204H8.59998C8.52032 8.0204 8.44143 8.00471 8.36782 7.97422C8.29422 7.94373 8.22734 7.89904 8.17101 7.84271C8.11467 7.78638 8.06999 7.7195 8.0395 7.64589C8.00901 7.57229 7.99332 7.4934 7.99332 7.41373V1.96707C7.99383 1.88059 7.97605 1.79499 7.94115 1.71587C7.90624 1.63675 7.855 1.56591 7.79079 1.50799C7.72657 1.45007 7.65084 1.40638 7.56855 1.3798C7.48626 1.35322 7.39928 1.34433 7.31332 1.35373C6.06182 1.48662 4.87349 1.97105 3.88577 2.75099C2.89804 3.53093 2.15126 4.57453 1.73179 5.76111C1.31232 6.94768 1.23728 8.22875 1.51536 9.45618C1.79345 10.6836 2.41329 11.8073 3.30321 12.6972C4.19313 13.5871 5.31677 14.2069 6.5442 14.485C7.77163 14.7631 9.0527 14.6881 10.2393 14.2686C11.4258 13.8491 12.4694 13.1023 13.2494 12.1146C14.0293 11.1269 14.5138 9.93857 14.6467 8.68707C14.6541 8.60215 14.6437 8.51663 14.6162 8.43594C14.5887 8.35526 14.5447 8.28119 14.487 8.21847C14.4293 8.15574 14.3592 8.10573 14.281 8.07163C14.2029 8.03752 14.1186 8.02008 14.0333 8.0204Z",
    fill: "#1271A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.8a90ad989233b31773b39c45550a8f09.svg";
export { ForwardRef as ReactComponent };